// extracted by mini-css-extract-plugin
export default {"root":"NlNdY","skeleton":"Xmh2a","title":"zKLiU"};